(function () {
  const selector = '[data-sl-home-hero]';

  function initHero(root) {
    if (!root || typeof window.Swiper === 'undefined') return false;

    const slider = root.querySelector('.sl-home-hero__slider');
    if (!slider) return true;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const enableLoop = slideCount > 1;

    new window.Swiper(slider, {
      loop: enableLoop,
      speed: 700,
      autoplay:
        root.dataset.autoplay === 'true' && enableLoop
          ? {
              delay: parseInt(root.dataset.autoplaySpeed || '3000', 10),
              disableOnInteraction: false,
            }
          : false,
      pagination:
        root.dataset.showPagination === 'true' && enableLoop
          ? {
              el: root.querySelector('.sl-home-hero__pagination'),
              clickable: true,
            }
          : false,
      navigation:
        root.dataset.showArrows === 'true' && enableLoop
          ? {
              nextEl: root.querySelector('.sl-home-hero__nav--next'),
              prevEl: root.querySelector('.sl-home-hero__nav--prev'),
            }
          : false,
      observer: true,
      observeParents: true,
    });

    root.dataset.slHomeHeroReady = 'true';
    return true;
  }

  function initAll(scope) {
    const container = scope || document;
    container.querySelectorAll(selector).forEach((root) => {
      if (!initHero(root)) {
        window.requestAnimationFrame(() => initHero(root));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
